module.exports = __webpack_public_path__ + "img/logo_Upage.ef0f19dd.png";